import { render, staticRenderFns } from "./Layer1.vue?vue&type=template&id=2311d942&scoped=true&"
import script from "./Layer1.vue?vue&type=script&lang=js&"
export * from "./Layer1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2311d942",
  null
  
)

export default component.exports